import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../fund/fund-components/shared-utils';
import {
  Fact,
  Title,
  Value,
} from './styles';

export default function MonetaryDataFact({
  label,
  value,
  nullReplacement,
  clazz,
}) {
  return (
    <Fact className={clazz}>
      <Title>{label}</Title>
      <Value>
        {value ? formatCurrency(value) : nullReplacement}
      </Value>
    </Fact>
  );
}

MonetaryDataFact.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  nullReplacement: PropTypes.string.isRequired,
  clazz: PropTypes.string,
};

MonetaryDataFact.defaultProps = {
  value: null,
  clazz: null,
};
